import { HEIGHT_UNITS } from 'consts/units';

const heightUnit = (state = HEIGHT_UNITS.feets, action) => {
  switch (action.type) {
    case 'SET_HEIGHT_UNIT':
      return action.payload;
    default:
      return state;
  }
};

export default heightUnit;
